<app-aumico-layout [hideFooter]="true">
    <ng-container header>
        <ham-page-header [title]="pageHeader.value | i18next" [hasBackButton]="false"></ham-page-header>
    </ng-container>
    <ng-container content>
        <div style="padding: 0">
            <aumico-companies-list2
                [currentLanguage]="currentLanguage"
                [defaultLanguage]="defaultLanguage"
                [userPreferredNumberOfDocumentsPerPage]="userPreferredNumberOfDocumentsPerPage"
                [organizationUsers]="organizationUsers$ | async"
                [currentUserId]="activeUserAumicoInternalId"
                [dismissedBanners]="dismissedBanners"
                [workflowOptions]="workflows"
                (editButtonClicked)="editCompany($event)"
                (numberOfDocumentsPerPageChanged)="onNumberOfDocumentsPerPageChanged($event)"
                (search)="doFilter($event)"
                (new)="createCompany()"
            ></aumico-companies-list2>
        </div>
    </ng-container>
</app-aumico-layout>
